module.exports = __webpack_public_path__ + "static/media/18ECA42.37611116.jpg";